export const getFetchContactAdminDetailsURL = (): string =>
	'/rest/internal/3/contactadministrator/configuration';
// TODO: Add API end point
export const buildPostSendMailToAdmin = (): string => '/rest/internal/3/contactadministrator';

export const defaultStateForContactAdminDetails = {
	isEnabled: false,
	message: null,
	to: null,
	replyTo: null,
	reCaptchaSharedKey: null,
} as const;
